import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ONBOARDING_BASE_PATH } from '@/constants/onboarding';

import { AuthenticatedRoot } from './pages/members/pages/AuthenticatedRoot/AuthenticatedRoot';
import Home from './pages/members/pages/Home/Home';
import Login from './pages/members/pages/Login/Login';
import MeetingDetails from './pages/members/pages/MeetingDetails';
import { NotFound } from './pages/members/pages/NotFound';
import Stepper from './pages/members/pages/Onboarding/components/Stepper';
import Onboarding from './pages/members/pages/Onboarding/Onboarding';
import OnboardingCompleted from './pages/members/pages/Onboarding/pages/OnboardingCompleted';
import OneTimeLogin from './pages/members/pages/OneTimeLogin';
import Root from './pages/members/pages/Root/Root';
import ZoomMeetingPage from './pages/members/pages/ZoomMeeting';

const Router = () => {
  return (
    <BrowserRouter basename={ONBOARDING_BASE_PATH}>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Root />}>
          <Route element={<AuthenticatedRoot />}>
            <Route index element={<Home />} />
            <Route path="/appointments/:appointmentId" element={<MeetingDetails />} />
            <Route path="/appointments/:appointmentId/meeting" element={<ZoomMeetingPage />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/one-time-login/:uid/:token" element={<OneTimeLogin />} />
          <Route path="/onboarding" element={<Onboarding />}>
            <Route path="/onboarding/:version/:step" element={<Stepper />} />
            <Route path="/onboarding/success" element={<OnboardingCompleted />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
